import React from 'react';
import { usePricing } from '../context/PricingContext';

const TabNavigation = () => {
  const { activePricingTab, switchTab } = usePricing();

  const tabs = [
    { id: 1, label: 'Self Filing with Assistance' },
    { id: 2, label: 'IP Attorney-Led Filing' }
  ];

  return (
    <div className="flex justify-center mb-8">
      <div className="inline-flex bg-gray-100 rounded-lg p-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => switchTab(tab.id)}
            className={`px-6 py-3 rounded-md text-sm sm:text-base font-semibold transition-all duration-300 ${
              activePricingTab === tab.id
                ? 'bg-white text-teal-600 shadow-md'
                : 'text-gray-600 hover:text-gray-900'
            }`}
            role="tab"
            aria-selected={activePricingTab === tab.id}
            tabIndex={activePricingTab === tab.id ? 0 : -1}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
